export const AutoCompleteStyling = {
   control: provided => ({
      ...provided,
      minHeight: 38,
      borderRadius: 4,
      border: "1px solid #D7DEE5",
   }),
   placeholder: provided => ({
      ...provided,
      color: "#74788D",
      fontSize: 14,
      padding: "0 6px",
   }),
   menuPortal: base => ({ ...base, zIndex: 9999 })
}

export const stageHoursSelectOptions = [
   {
      label: "2.5 Hrs",
      value: "2.5",
   },
   {
      label: "5 Hrs",
      value: "5",
   },
   {
      label: "7.5 Hrs",
      value: "7.5",
   },
   {
      label: "10 Hrs",
      value: "10",
   },
]
